import { Product } from "../../types/Product";
import { useProductTranslations } from "../../hooks/TranslationHooks";
import { useContext } from "react";
import { CartContext } from "../../functional-components/CartContext";
import BjelinButton from "../BjelinButton";
import { getCurrentSite } from "../../utils/SiteUtils";
import SamplePriceArea from "./SamplePriceArea";
import { useLocSetting } from "../../hooks/SettingsHooks";

function OrderSampleColumn({ product }: { product?: Product }) {
  const site = getCurrentSite();
  const tp = useProductTranslations();
  const { loggedAddSampleToCart } = useContext(CartContext);
  const free_samples = useLocSetting("free_samples", 0);
  const { hasSampleInStock, sampleSaleable } = product || {};

  return product && sampleSaleable ? (
    <div className={"order-sample-column mb-5"}>
      <h3>{tp("order_sample")}</h3>
      <SamplePriceArea product={product} className={"mb-3"} />
      <div className={"d-inline-block"}>
        <BjelinButton
          icon={hasSampleInStock ? "cart-plus" : undefined}
          icon_position={"before"}
          className={"sample-btn"}
          color={"primary"}
          disabled={!hasSampleInStock}
          onClick={e => {
            if (hasSampleInStock) {
              loggedAddSampleToCart(product);
              e.stopPropagation(true);
            }
          }}
        >
          {hasSampleInStock ? tp("add_to_cart") : tp("sample_out_of_stock")}
        </BjelinButton>
        <div className={"text-center text-muted"}>
          {tp(`order_sample_text.${site}`, {
            free_samples,
            defaultValue: tp("order_sample_text")
          })}
        </div>
      </div>
    </div>
  ) : null;
}

export default OrderSampleColumn;
